import React from 'react';
import StudentTestimonialsCard from './StudentTestimonialsCard';
import Marquee from 'react-fast-marquee';
import { useRouter } from 'next/router';

const StudentTestimonials = ({ textTestimonials, totalTextTestimonial }) => {
  const router = useRouter();
  let isDarkTheme = false;
  if (['/success-stories'].some((path) => router.asPath.startsWith(path))) isDarkTheme = true;
  return (
    <div className={`${isDarkTheme ? 'bg-black' : 'bg-white'}   py-12  `}>
      <p
        className={`${
          isDarkTheme ? 'text-white' : 'text-black'
        } mb-12 text-center font-satoshi-medium text-4xl font-medium  leading-normal md:text-5xl`}
      >
        {' '}
        Hear straight from our <span className="bg-red p-1 text-white">students</span>
      </p>
      <div className="relative">
        <div className="mt-4">
          <Marquee direction={'right'} speed={100}>
            {textTestimonials.map((obj, index) => (
              <div key={index}>
                <StudentTestimonialsCard
                  avatar={obj?.attributes?.avatar}
                  name={obj?.attributes?.studentName}
                  companyLogo={obj?.attributes?.companyLogo}
                  designation={obj?.attributes?.studentDesignation}
                  description={obj?.attributes?.tagline}
                  isDarkTheme={isDarkTheme}
                />
              </div>
            ))}
          </Marquee>
        </div>
        <div className="mt-2">
          <Marquee direction={'left'} speed={120}>
            {textTestimonials.map((obj, index) => (
              <div key={index}>
                <StudentTestimonialsCard
                  avatar={obj?.attributes?.avatar}
                  name={obj?.attributes?.studentName}
                  companyLogo={obj?.attributes?.companyLogo}
                  designation={obj?.attributes?.studentDesignation}
                  description={obj?.attributes?.tagline}
                  isDarkTheme={isDarkTheme}
                />
              </div>
            ))}
          </Marquee>
        </div>
      </div>
    </div>
  );
};

export default StudentTestimonials;
